import { render, staticRenderFns } from "./EmployeeGrantInfo.vue?vue&type=template&id=16943248&scoped=true&"
import script from "./EmployeeGrantInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrantInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16943248",
  null
  
)

export default component.exports